import type { GetPatientResponse } from '../../../../services/patientCard';
import { formatPhone, isValidEmail, isValidPhone } from '../../../../utils/contact';
import { formatDateOnly } from '../../../../utils/dates';
import { ReadOnlyInput } from './SubmissionStepParts';

interface PatientDetailsStepProps {
    card: GetPatientResponse;
}

// Mirrors dashboard patientDetails.tsx: same centered column, row grouping,
// labels and validation messages, rendered read-only.
export function PatientDetailsStep({ card }: PatientDetailsStepProps) {
    const phoneValid = card.phone ? isValidPhone(card.phone) : true;
    const emailValid = card.email ? isValidEmail(card.email) : true;

    return (
        <div className="w-full max-w-2xl mx-auto space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <ReadOnlyInput label="First Name" value={card.firstName} />
                <ReadOnlyInput label="Last Name" value={card.lastName} />
            </div>

            <div className="grid grid-cols-2 gap-6">
                <ReadOnlyInput label="Gender" value={card.gender} />
                <ReadOnlyInput label="Date of Birth" value={formatDateOnly(card.dateOfBirth)} />
            </div>

            <ReadOnlyInput
                label="Phone"
                value={card.phone && phoneValid ? formatPhone(card.phone) : card.phone}
                invalidHint={phoneValid ? null : 'Please enter a valid US or Canadian phone number'}
            />

            <ReadOnlyInput
                label="Email"
                value={card.email}
                invalidHint={emailValid ? null : 'Please enter a valid email address'}
            />

            <ReadOnlyInput label="Practice" value={card.practice?.name} />
        </div>
    );
}
